import React, {useState} from "react";
import {SfcShellAppBar, SfcShellAppBarSearch} from "@synerg/react-components";
import SearchResults from "../pages/SearchResults";
import NavLoginUser from "./LoginLogout";
import {NavHelp} from "./NavHelp";
import {useNavigate, useMatch} from 'react-router-dom';
import {NavFeedback} from "./shell-app-bar/NavFeedback";

import './articles/previews/GuidesPrintView/WholeGuidePrintView/style.css'

export default function AppBar() {
    const [searchKey, setSearchedKey] = useState('');
    const [isClose, setIsClose] = useState(false);
    const navigate = useNavigate();
    const isSearchResultsPage = useMatch('/searchresults');
    const shouldHideSearchPreview = window.innerWidth < 1024 || Boolean(isSearchResultsPage);

    const onChangeHandler = (evt) => {
        setSearchedKey(evt.target.value);

        if (!shouldHideSearchPreview) return

        navigateToSearchResult(evt.target.value)
    }

    const onClose = () => {
        setIsClose(!isClose);
    }

    const navigateToSearchResult = (query) => {
        const params = new URLSearchParams();
        params.set('index', '')
        params.set('from', '0')
        params.set('size', '10')
        params.set('query', (query !== undefined) ? query : searchKey)

        return navigate({
            pathname: "/searchresults",
            search: params.toString()
        })
    }

    const handleOnSfcSearch = (e) => {
        if (e.detail) {
            navigateToSearchResult(e.detail);
        }
    }

    const appBarClicked = (e) => {
        if (e.clientX > 61 && e.clientX < 81 && e.clientY > 26 && e.clientY < 50) {
            navigate('/')
        }
    }

    return (
        <SfcShellAppBar
            className="no-print cursor-pointer"
            style={{zIndex: '1061'}}
            slot="app-bar"
            role="banner"
            size="default"
            data-testid='app-header'
            onClick={(e) => appBarClicked(e)}
        >
            <div className="cursor-pointer" onClick={() => navigate('/')}>
                <div className="logo-divider no-branding"/>
                <div className="branding-area font-semibold">Developer Resources</div>
            </div>
            <SfcShellAppBarSearch
                slot="search"
                onSfcQueryChanged={onChangeHandler}
                onSfcPanelClosed={onClose}
                onSfcSearch={handleOnSfcSearch}
            >
                {
                    !shouldHideSearchPreview &&
                    <SearchResults
                        searchedKey={searchKey}
                        panelClosed={isClose}
                        navigateToSearchResult={navigateToSearchResult}
                    />
                }
            </SfcShellAppBarSearch>

            <NavFeedback/>

            <NavHelp/>

            <NavLoginUser/>

        </SfcShellAppBar>


    );
}
